import { Field, ErrorMessage } from "formik";
import { get, set } from "lodash";
import { IMAGE_BASE_URL, IMAGE_URL } from "../../config";
import { formatUnderscoreToSpace } from "../../utils/text-format";

export const FormFileUploadField = ({
  label = "Upload File",
  name = "fileField",
  labelClassName = "",
  className = "",
  previewClassName = "",
  accept = "*",
}) => {
  const handleFileChange = async (event, form, name) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(IMAGE_URL, {
        method: "POST",
        body: formData,
      });

      if (response.status === 200) {
        const data = await response.json();
        const filePath = data?.data?.filePath;
        const fullUrl = filePath.startsWith("http")
          ? filePath
          : `${IMAGE_BASE_URL}${filePath}`;

        const updatedValues = { ...form.values };
        set(updatedValues, name, {
          url: fullUrl,
          name: file.name,
        });
        form.setValues(updatedValues);
      } else {
        console.error("Upload failed", response.statusText);
        alert("File upload failed!");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("An error occurred during upload!");
    }
  };

  const handleRemoveFile = (form, name) => {
    const updatedValues = { ...form.values };
    set(updatedValues, name, null);
    form.setValues(updatedValues);
  };

  return (
    <Field name={name}>
      {({ form, meta }) => {
        const fileData = get(form.values, name);
        const error = meta.touched && meta.error;

        return (
          <div className={`flex flex-col gap-1 w-full ${className}`}>
            {label && (
              <label
                htmlFor={name}
                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${
                  error ? "text-errorColor" : labelClassName
                }`}
              >
                {formatUnderscoreToSpace(label)}
              </label>
            )}

            {fileData ? (
              <div
                className={`border p-2 rounded flex items-center justify-between ${previewClassName}`}
              >
                <span className="text-sm text-gray-800 truncate">
                  {fileData.name}
                </span>
                <button
                  type="button"
                  onClick={() => handleRemoveFile(form, name)}
                  className="ml-2 text-xs text-white bg-red-500 hover:bg-red-600 rounded px-2 py-0.5"
                >
                  Remove
                </button>
              </div>
            ) : (
              <label className="cursor-pointer w-fit">
                <div
                  className={`border-[1.5px] border-dashed rounded-md px-4 py-2 text-gray-600 hover:bg-gray-50 ${
                    error ? "border-errorColor" : "border-gray-400"
                  }`}
                >
                  Choose File
                </div>
                <input
                  type="file"
                  accept={accept}
                  className="hidden"
                  onChange={(event) => handleFileChange(event, form, name)}
                />
              </label>
            )}

            <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
              <ErrorMessage name={name} />
            </label>
          </div>
        );
      }}
    </Field>
  );
};
